<script setup>
import { useAuthStore } from "@/stores";
import { ElPopover } from "element-plus";
import { computed } from "vue";
import { useWeeklyReportStore } from "@/stores/useWeeklyReportSettings";
import { useRoute } from "vue-router";
// import WeeklyReportSettings from "@/components/layout/WeeklyReportSettings.vue";

const route = useRoute();
const weeklyReportStore = useWeeklyReportStore();
const authStore = useAuthStore();
const isSuperAdmin = computed(() => authStore.isSuperAdmin);
const isAccountManager = computed(() => authStore.isAccountManager);
const routes = [
  {
    name: "Manage Users",
    to: "/central/manage-users",
    urlType: "central",
  },
  {
    name: "Manage Curriculums",
    to: "/manage/curriculums",
    urlType: "lms",
  },
  {
    name: "Manage Courses",
    to: "/manage/courses",
    urlType: "lms",
  },
  {
    name: "Manage Playlist",
    to: "/manage/playlist",
    urlType: "lms",
  },
  {
    name: "Usage Report",
    to: "/usage-report",
    urlType: "lms",
  },
];

const isExist = computed(() => routes.some((r) => r.to === route.fullPath));

const filteredRoutes = computed(() => {
  return routes.filter((route) => {
    if (
      !isSuperAdmin.value &&
      !isAccountManager.value &&
      ( route.name.toLowerCase() === "manage courses" || route.name.toLowerCase() === "manage playlist" )
    ) {
      return false;
    }

    if (
      !isSuperAdmin.value &&
      !isAccountManager.value &&
      route.name.toLowerCase() === "manage lms settings"
    ) {
      return false;
    }

    if (
      !isSuperAdmin.value &&
      route.name.toLowerCase() === "manage curriculums"
    ) {
      return false;
    }

    if (!isSuperAdmin.value  && route.name.toLowerCase() === "usage report") {
      return false;
    }

    return true;
  });
});

const handleClickShow = (route) => {
  switch (route.name.toLowerCase()) {
    case "manage weekly report":
      weeklyReportStore.showDialog();
      break;

    default:
      break;
  }
};
</script>
<template>
  <div v-bind="$attrs">
    <slot :filteredRoutes="filteredRoutes">
      <el-popover
        :width="220"
        popper-style="padding: 5px !important;z-index: 3000 !important; background-color: rgb(0 44 115)"
      >
        <template #reference>
          <a
            class="px-1 pt-1 text-sm w-full h-full flex justify-center items-center font-medium"
            :class="{
              'text-white border-kintz-primary-2 border-b-2': isExist,
              'hover:border-white border-b-2 border-transparent hover:text-white text-untitled-gray-400':
                !isExist,
            }"
          >
            Admin Portal
          </a>
        </template>
        <template #default>
          <div class="w-full flex flex-col justify-start items-start">
            <div
              class="w-full"
              v-for="(r, index) in filteredRoutes"
              :key="index"
            >
              <router-link
                class="w-full px-2 py-2 text-sm flex justify-start items-start"
                :class="{
                  'text-white': route.fullPath === r.to,
                  'hover:text-white text-untitled-gray-400':
                    route.fullPath !== r.to,
                }"
                :to="r.to"
                v-if="r.urlType === 'lms'"
              >
                {{ r.name }}
              </router-link>
              <a
                :href="r.to"
                v-else-if="r.urlType === 'central'"
                target="_blank"
                class="w-full px-2 py-2 text-sm flex justify-start items-start hover:text-white text-untitled-gray-400"
                >{{ r.name }}</a
              >
              <button
                v-else
                class="w-full px-2 py-2 text-sm hover:text-white text-untitled-gray-400 flex justify-start items-start"
                @click="handleClickShow(r)"
              >
                {{ r.name }}
              </button>
            </div>
          </div>
        </template>
      </el-popover>
    </slot>
  </div>
</template>
<style lang="scss" scoped></style>
